module.exports = __webpack_public_path__ + "static/media/1.2c6b8adc.jpg";